/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Save Search Utility
 */

import { ZOOM_HOOD, getQueryBounds } from '@zcode/nr-utils'
import type { Filters, Location, SaveSearchLocation } from '@zcode/state-type'
import type { O } from 'ts-toolbelt'
import * as Utils from './utils'

const getCityAndHoodName = (loc: Location | SaveSearchLocation) => {
  const { zoom, hoodName, cityName } = loc
  const data: { city?: string | null; hood?: string | null } = {}
  if (zoom) {
    if (zoom >= ZOOM_HOOD && hoodName) {
      data.hood = hoodName
    } else {
      data.city = cityName
    }
  } else {
    data.city = cityName
    data.hood = hoodName
  }

  return data
}

export const createFilterCopy = (filters: Filters, location: Location | SaveSearchLocation) => {
  const filterCopy: O.Writable<
    Filters & { city?: string | null | undefined; hood?: string | null | undefined }
  > = { ...filters }
  // retrieve location information from pLocation service
  // @ts-expect-error location.bounds doesn't exist (at least that's what the types say 🤷‍♂️)
  if (location.bounds) {
    Utils.oforEach<NonNullable<ReturnType<typeof getQueryBounds>>>(
      // @ts-expect-error location.bounds doesn't exist (at least that's what the types say 🤷‍♂️)
      getQueryBounds(location.bounds),
      (item, key) => {
        filterCopy[key] = item
      }
    )
  } else if (location.box) {
    const box = location.box
    Object.assign(filterCopy, box)
  }

  // use zoom level to decide whether to use hood/city on the saved search name
  if (location) {
    const data = getCityAndHoodName(location)
    filterCopy.hood = data.hood
    filterCopy.city = data.city
    // don't save with bounds + url since the result will be intersection of the bounds and url
    // @ts-expect-error location.bounds doesn't exist (at least that's what the types say 🤷‍♂️)
    if (!location.bounds) {
      filterCopy.url = location.url
    }
  }

  return filterCopy
}
